<template>
  <section id="businessLoyaltyCardNumber">
    <div class="container">
      <div class="header">
        <h5>Business</h5>
        <CancelButton></CancelButton>
      </div>
      <form action="#" autocomplete="off"> 
        <div class="column">
          <h5>
          Easy as that.
          <br>Welcome to the Shaves family!
        </h5>
        <p>Could you let us know how you would like to collect your card?</p>

        <div class="columns">
          
          <div class="column is-two-thirds-tablet is-half-desktop  is-one-fifths-widescreen is-one-third-fullhd">
            <div class="content">
              <div class="collectPost">
                <input type="radio" id="collectInStore" v-model="collectpost.type"  value="collect" :checked="collectpost.type == 'collect'">
                <label for="collectInStore"><span>I'd like to </span>collect <span>it </span>in-store </label>

                <input type="radio" v-model="collectpost.type" id="postItToMe" value="post" :checked="collectpost.type == 'post'">
                <!-- <input :checked="collectpost == 'post'" type="radio" v-model="collectpost" id="postItToMe" value="post"> -->
                <label for="postItToMe">Post it to me<span> please</span></label>
              </div>
            </div>
          </div>

          <!-- <div class="column is-two-fifths">
            <div class="control">
              <label for="cardNumber">
                New loyalty card number
                <span>*</span>
              </label>
              <input
                v-validate="'required'"
                v-mask="'######'"
                v-model="cardNumber"
                id="cardNumber"
                class="input"
                type="tel"
                required
              >
            </div>
          </div> -->
        </div>
        <div class="columns control" v-if="collectpost.type == 'collect'">
          <div class="column is-one-third">
            <label for="storeName">Store Name<span>*</span></label>
                        <div class="select">
              <select
                name="storeName"
                v-validate="'required'"
                v-model="storeName"
                id="storeName"
                required
              >
                <option value disabled>Select Option</option>
                <option value="Ballito">Ballito</option>
                <option value="Bluff">Bluff</option>
                <option value="Durban">Durban</option>
                <option value="Hillcrest">Hillcrest</option>
                <option value="Pinetown">Pinetown</option>
                <option value="Sandton">Sandton</option>
                <option value="Umhlanga">Umhlanga</option>
              </select>
            </div>
          </div>
        </div>
        <div class="columns">
          <div v-if="storeName == 'Ballito'" class="column is-one-third">
            <label for="storeAddress">Store Address</label>
            <p>Ballito Home Improvement Centre Moffat Drive, Ballito</p>
          </div>
          <div v-if="storeName == 'Bluff'" class="column is-one-third">
            <label for="storeAddress">Store Address</label>
            <p>142 Archary Road, Bluff Durban South 4052</p>
          </div>
          <div v-if="storeName == 'Durban'" class="column is-one-third">
            <label for="storeAddress">Store Address</label>
            <p>106 Intersite Avenue Umgeni Business Park, 4091, Durban</p>
          </div>
          <div v-if="storeName == 'Hillcrest'" class="column is-one-third">
            <label for="storeAddress">Store Address</label>
            <p>45 Old Main Road, Hillcrest, 3610</p>
          </div>
          <div v-if="storeName == 'Pinetown'" class="column is-one-third">
            <label for="storeAddress">Store Address</label>
            <p>39 Josiah Gumede Road, Pinetown, Durban 3610</p>
          </div>
          <div v-if="storeName == 'Sandton'" class="column is-one-third">
            <label for="storeAddress">Store Address</label>
            <p>Kramerville West, Commerce Cres, Sandton, Gauteng</p>
          </div>
          <div v-if="storeName == 'Umhlanga'" class="column is-one-third">
            <label for="storeAddress">Store Address</label>
            <p>Millenium Home Ctr Tetford Circle, Umhlanga, 4320</p>
          </div>
        </div>

        <div class="control" v-if="collectpost.type == 'post'">   
          <div class="columns">
          <div class="column is-one-third">
            
            <label >Would you like you card delivered to a different address than your street address?</label>
            <div class="content">
              <div class="titleContainer yesNo">
                <input type="radio" id="addressOld" v-model="address.type"  value="yes" :checked="address.type == 'yes'">
                <label for="addressOld">Same</label>

                <input type="radio" id="addressNew" v-model="address.type"  value="no" :checked="address.type == 'no'">
                <label for="addressNew">New</label>
              </div>
            </div>
          </div>  
        </div>     
          <div class="control"   v-if="address.type == 'no'">
            <div class="columns">
            <div class="column is-one-third">
            <label for="poBox">Address Or PO Box<span>*</span></label>
              <input v-validate="'required'" v-model="poBox" id="poBox" class="input" type="text">
            </div>

            <div class="column is-one-third">
              <label for="suburbName">Suburb<span>*</span></label>
              <input v-validate="'required'" v-model="suburbName" id="suburbName" class="input" type="text">
            </div>
          </div>
          
          <div class="columns">
           <div class="column is-one-third">
              <label for="province">Province<span>*</span></label>
              <!-- <input v-validate="'required'" v-model="province" id="province" class="input" type="text"> -->
              <div class="select">
              <select
                name="Province"
                v-validate="'required'"
                v-model="province"
                id="province"
                required
              >
                <option value disabled selected>Select Option</option>
                <option value="Ballito">Ballito</option>
                <option value="Bluff">Bluff</option>
                <option value="Durban">Durban</option>
                <option value="Hillcrest">Hillcrest</option>
                <option value="Pinetown">Pinetown</option>
                <option value="Sandton">Sandton</option>
                <option value="Umhlanga">Umhlanga</option>                
              </select>
            </div>
            </div>
            <div class="column is-one-third">
              <label for="postalCode">Postal Code<span>*</span></label>
              <input v-validate="'required'" v-model="postalCode" id="postalCode" class="input" type="text">
            </div>
          </div>
        </div>        
        
        </div>
        </div>
      </form>

      <div class="actions">
        <button @click="toBusinessthanks()" class="button is-danger ml-auto">Done</button>
      </div>
    </div>
  </section>
</template>


<script>
import CancelButton from "../../components/actions/CancelButton";
import { mask } from "vue-the-mask";
import axios from "axios";
// import Autocomplete from 'vuejs-auto-complete';
import alertify from "alertifyjs";

export default {
  name: "businessloyalty",
  directives: { mask },
  components: {
    CancelButton,
    // Autocomplete,
  },
  data() {
    return {
      consultants: [],
      selectedStore: null,
      cardNumber: null,
      storeName: '',
      collectpost: {
        type:'collect',
        content:null
      },      
      address: {
        type:'yes',
        content:null
      },
      storeAddress:[
        {id:1, description:'Ballito Home Improvement Centre Moffat Drive, Ballito', storeName:'Ballito'},
        {id:2, description:'142 Archary Road, Bluff Durban South 4052', storeName:'Bluff'},
        {id:3, description:'106 Intersite Avenue Umgeni Business Park, 4091, Durban', storeName:'Durban'},
        {id:4, description:'45 Old Main Road, Hillcrest, 3610', storeName:'Hillcrest'},
        {id:5, description:'39 Josiah Gumede Road, Pinetown, Durban 3610', storeName:'Pinetown'},
        {id:6, description:'Kramerville West, Commerce Cres, Sandton, Gauteng', storeName:'Sandton'},
        {id:7, description:'Millenium Home Ctr Tetford Circle, Umhlanga, 4320', storeName:'Umhlanga'},
      ],
      selectedAddress:'',
      poBox:'',
      suburbName:'',
      province:'',
      postalCode:''
      
    };
  },
  methods: {
    selectMyAddress(val){
      this.storeName = val.display
    },

    setConsultant(val){
      this.selectedConsultant = val.display
    },
    toBusinessthanks() {
      this.$validator.validate().then(result => {
        if (!result) {
          this.loading = false;
          alertify.error("Please check all fields are filled in correctly.");
          if(this.selectedConsultant == ''){
            document.body.classList.add('invalidField')
          }
        } else {
          if (this.storeName) { 
            this.$gtag.event('collect_instore', {
              'event_category': 'engagement',
              'event_label': this.storeName,
              'value': ''
            });
          }
          this.$store.commit("SAVE_BUSINESS_CARD_DETAILS", {
            cardNumber: this.cardNumber,
            consultant: this.selectedConsultant,
            storeName: this.storeName,
            poBox: this.poBox,
            suburbName: this.suburbName,
            province: this.province,
            postalCode: this.postalCode,
            address: this.address,
          });
          axios
            .post(
              "https://websiteapi.shaves.co.za/api/signup/business",
              this.$store.state.business
            )
            .then(response => {
              this.$gtag.event('business_signup_success', {
                'event_category': 'engagement',
                'event_label': 'Customer Successfully Registered',
                'value': ''
              });
              console.log(response);
              this.$router.push("/businessthanks");
            })
            .catch(error => {
              this.$gtag.event('business_signup_failure', {
                'event_category': 'engagement',
                'event_label': 'Error Registering Customer',
                'value': ''
              });
              console.log("ERRROR");
              alertify.error(error.response.data.message);
            });
        }
      });
    }
  },
  mounted() {
    axios.get("https://websiteapi.shaves.co.za/api/consultants").then(response => {
      this.consultants = response.data;
    });

    this.cardNumber = this.$store.state.business.cardinfo.cardNumber
    this.selectedConsultant = this.$store.state.business.cardinfo.consultant
    this.storeName = this.$store.state.business.cardinfo.storeName
    this.poBox = this.$store.state.business.cardinfo.poBox
    this.suburbName = this.$store.state.business.cardinfo.suburbName
    this.province = this.$store.state.business.cardinfo.province
    this.postalCode = this.$store.state.business.cardinfo.postalCode
    this.address = this.$store.state.business.cardinfo.address

  },
  watch: {
    selectedConsultant: function(){
      if(this.salesPerson != ''){
        document.body.classList.remove('invalidField')
      }
    },
  }
};
</script>
